import { module } from 'angular';
import templateBuilderGeoDisplay from './builder/display.html';
import templateBuilderGeoValidate from './builder/validate.html';

export default module('app').run(/* @ngInject */ (
	/** @type {import('angular').ITemplateCacheService} */ $templateCache,
) => {
	$templateCache.put('kform/components/geo/display.html', templateBuilderGeoDisplay);
	$templateCache.put('kform/components/geo/validate.html', templateBuilderGeoValidate);
});
